import { Card, CardContent, Grid } from "@material-ui/core";
import * as React from "react";
import { BooleanInput, Edit, FormWithRedirect, required, TextInput, Toolbar } from "react-admin";
import TiptapRichTextInputField from "../../../Components/TiptapRichTextInput";
import { useVerifyPermission } from "@airborne/react-admin";

const MailManagementEdit = props => {
  useVerifyPermission("mailmanagements", "edit");
  return (
    <Edit title={"Mail Management Edit"} component="div" {...props}>
      <FormWithRedirect
        {...props}
        render={(formProps: any) => {
          return (
            <Card>
              <form>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      <TextInput source="customer.ownerCode" label="Customer" fullWidth multiline disabled />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      <BooleanInput source="isMailFreeze" label={"Deactivate"} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={4} />
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      <TextInput source="to" label="TO" fullWidth multiline />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      <TextInput source="cc" label="CC" fullWidth multiline />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextInput source="subject" label="Subject" validate={required()} fullWidth multiline />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TiptapRichTextInputField source="body" validate={[required()]} />
                    </Grid>
                  </Grid>
                </CardContent>
                <Toolbar
                  {...props}
                  placeholder=""
                  record={formProps.record}
                  basePath={formProps.basePath}
                  undoable={true}
                  invalid={formProps.invalid}
                  handleSubmit={formProps.handleSubmit}
                  saving={formProps.saving}
                  resource="mailmanagements"
                />
              </form>
            </Card>
          );
        }}
      />
    </Edit>
  );
};

export default MailManagementEdit;
